@if (dialogData?.text) {
  <h1 mat-dialog-title>
    {{ dialogData?.text | translate }}
  </h1>
}

<mat-dialog-content>
  <div class="form-container">
    <mat-form-field subscriptSizing="dynamic">
      <input matInput type="text" [formControl]="input" />
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button color="secondary" (click)="onClose()">
    {{ "base.cancel" | translate }}
  </button>
  <button mat-flat-button color="primary" (click)="onSave()">
    {{ "base.save" | translate }}
  </button>
</mat-dialog-actions>
